import { localize } from "render/context/InternationalizationContext";

const CheckedIn = localize({
  en_GB: "checked in",
  sv_SE: "incheckad",
});

export const Trans = { CheckedIn };
